import React, { useState } from 'react';
import { X } from 'lucide-react';
import { stylistAPI } from '../../../../services/api';

const SEASONS = [
  { value: 'лето', label: 'Лето' },
  { value: 'зима', label: 'Зима' },
  { value: 'межсезонье', label: 'Межсезонье' },
  { value: 'круглогодичная', label: 'Круглогодичная' },
];

const CreateCapsuleModal = ({ clientId, onClose, onCreated }) => {
  const [formData, setFormData] = useState({
    name: '',
    season: 'круглогодичная',
    description: '',
    event_types: []
  });
  const [eventInput, setEventInput] = useState('');
  const [loading, setLoading] = useState(false);

  const handleAddEvent = () => {
    if (eventInput.trim() && !formData.event_types.includes(eventInput.trim())) {
      setFormData({ ...formData, event_types: [...formData.event_types, eventInput.trim()] });
      setEventInput('');
    }
  };

  const handleRemoveEvent = (idx) => {
    setFormData({ 
      ...formData, 
      event_types: formData.event_types.filter((_, i) => i !== idx) 
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name.trim()) {
      alert('Введите название капсулы');
      return;
    }

    setLoading(true);
    try {
      const result = await stylistAPI.createCapsule(clientId, formData);
      onCreated(result.capsule_id);
    } catch (err) {
      console.error('Error creating capsule:', err);
      alert('Ошибка при создании капсулы');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div 
      onClick={onClose}
      style={{
        position: 'fixed',
        inset: 0,
        backgroundColor: 'rgba(0,0,0,0.6)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 'var(--space-l)',
        zIndex: 1000
      }}
    >
      <div 
        onClick={(e) => e.stopPropagation()}
        style={{
          backgroundColor: 'var(--white)',
          maxWidth: '500px',
          width: '100%',
          maxHeight: '90vh',
          overflow: 'auto'
        }}
      >
        <div style={{
          padding: 'var(--space-l)',
          borderBottom: '1px solid var(--soft-gray)',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <h3 style={{ fontFamily: 'var(--font-display)', fontSize: '1.25rem', fontWeight: 400 }}>
            Создать капсулу
          </h3>
          <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '4px' }}>
            <X size={20} />
          </button>
        </div>

        <form onSubmit={handleSubmit} style={{ padding: 'var(--space-l)' }}>
          {/* Name */}
          <div style={{ marginBottom: 'var(--space-l)' }}>
            <label style={{
              display: 'block',
              fontFamily: 'var(--font-body)',
              fontSize: '0.75rem',
              letterSpacing: '1px',
              textTransform: 'uppercase',
              color: 'var(--mid-gray)',
              marginBottom: 'var(--space-s)'
            }}>
              Название *
            </label>
            <input
              type="text"
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              placeholder="Осень в городе, Отпуск у моря..."
              style={{
                width: '100%',
                padding: '12px 16px',
                fontFamily: 'var(--font-body)',
                fontSize: '0.9375rem',
                border: '1px solid var(--soft-gray)',
                boxSizing: 'border-box'
              }}
            />
          </div>

          {/* Season */}
          <div style={{ marginBottom: 'var(--space-l)' }}>
            <label style={{
              display: 'block',
              fontFamily: 'var(--font-body)',
              fontSize: '0.75rem',
              letterSpacing: '1px',
              textTransform: 'uppercase',
              color: 'var(--mid-gray)',
              marginBottom: 'var(--space-s)'
            }}>
              Сезон *
            </label>
            <div style={{ display: 'flex', gap: 'var(--space-s)', flexWrap: 'wrap' }}>
              {SEASONS.map((season) => (
                <button
                  key={season.value}
                  type="button"
                  onClick={() => setFormData({ ...formData, season: season.value })}
                  style={{
                    padding: '10px 16px',
                    backgroundColor: formData.season === season.value ? 'var(--black)' : 'var(--cream)',
                    color: formData.season === season.value ? 'var(--white)' : 'var(--charcoal)',
                    border: 'none',
                    fontFamily: 'var(--font-body)',
                    fontSize: '0.875rem',
                    cursor: 'pointer'
                  }}
                >
                  {season.label}
                </button>
              ))}
            </div>
          </div>

          {/* Description */}
          <div style={{ marginBottom: 'var(--space-l)' }}>
            <label style={{
              display: 'block',
              fontFamily: 'var(--font-body)',
              fontSize: '0.75rem',
              letterSpacing: '1px',
              textTransform: 'uppercase',
              color: 'var(--mid-gray)',
              marginBottom: 'var(--space-s)'
            }}>
              Описание
            </label>
            <textarea
              value={formData.description}
              onChange={(e) => setFormData({ ...formData, description: e.target.value })}
              placeholder="Базовый гардероб для офиса и встреч..."
              rows={3}
              style={{
                width: '100%',
                padding: '12px 16px',
                fontFamily: 'var(--font-body)',
                fontSize: '0.9375rem',
                border: '1px solid var(--soft-gray)',
                boxSizing: 'border-box',
                resize: 'vertical'
              }}
            />
          </div>

          {/* Event Types */}
          <div style={{ marginBottom: 'var(--space-l)' }}>
            <label style={{
              display: 'block',
              fontFamily: 'var(--font-body)',
              fontSize: '0.75rem',
              letterSpacing: '1px',
              textTransform: 'uppercase',
              color: 'var(--mid-gray)',
              marginBottom: 'var(--space-s)'
            }}>
              Для каких событий
            </label>
            <div style={{ display: 'flex', gap: 'var(--space-s)', marginBottom: 'var(--space-s)' }}>
              <input
                type="text"
                value={eventInput}
                onChange={(e) => setEventInput(e.target.value)}
                onKeyPress={(e) => e.key === 'Enter' && (e.preventDefault(), handleAddEvent())}
                placeholder="офис, свидание, прогулка..."
                style={{
                  flex: 1,
                  padding: '10px 12px',
                  fontFamily: 'var(--font-body)',
                  fontSize: '0.875rem',
                  border: '1px solid var(--soft-gray)'
                }}
              />
              <button 
                type="button" 
                onClick={handleAddEvent}
                style={{
                  padding: '10px 16px',
                  backgroundColor: 'var(--cream)',
                  border: 'none',
                  cursor: 'pointer',
                  fontFamily: 'var(--font-body)',
                  fontSize: '0.875rem'
                }}
              >
                +
              </button>
            </div>
            {formData.event_types.length > 0 && (
              <div style={{ display: 'flex', gap: 'var(--space-s)', flexWrap: 'wrap' }}>
                {formData.event_types.map((event, idx) => (
                  <span 
                    key={idx}
                    style={{
                      padding: '4px 10px',
                      backgroundColor: 'var(--cream)',
                      fontSize: '0.8125rem',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '6px'
                    }}
                  >
                    {event}
                    <button 
                      type="button"
                      onClick={() => handleRemoveEvent(idx)}
                      style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
                    >
                      <X size={12} />
                    </button>
                  </span>
                ))}
              </div>
            )}
          </div>

          {/* Submit */}
          <button
            type="submit"
            disabled={loading || !formData.name.trim()}
            style={{
              width: '100%',
              padding: '16px',
              backgroundColor: 'var(--black)',
              color: 'var(--white)',
              border: 'none',
              fontFamily: 'var(--font-body)',
              fontSize: '0.875rem',
              letterSpacing: '1px',
              textTransform: 'uppercase',
              cursor: loading ? 'not-allowed' : 'pointer',
              opacity: loading ? 0.7 : 1
            }}
          >
            {loading ? 'Создание...' : 'Создать капсулу'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default CreateCapsuleModal;
